<style lang="postcss">
  .neonText {
    color: white;
    text-shadow: 0 0 42px #f472b6, 0 0 82px #f472b6;
  }
  .inuText {
    color: #da9cfb;
  }
  .solanaText {
    @apply text-pink-400;
  }

  /* Additional styling */
  .homepage {
    transition-property: transform;
    transform-origin: center;
    transition-timing-function: linear;
    transition: all 1.25s ease-out;
  }
  .homepage:hover {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }

  .bannerOpacity {
    opacity: 0;
    transition: opacity 3s ease 0s;
  }

  :global(.socialImgs:hover) {
    -webkit-transform:scale(1.5); /* Safari and Chrome */
    -moz-transform:scale(1.5); /* Firefox */
    -ms-transform:scale(1.5); /* IE 9 */
    -o-transform:scale(1.5); /* Opera */
    transform:scale(1.5);

    transition: all 0.3s linear;
  }
</style>

<div class="mx-auto grid gap-2 grid-cols-2 place-items-center border-red-900" style="max-width: 100rem; height: 50vh" in:fade="{{duration: 500}}">
  <div class="bannerOpacity border-blue-900 flex flex-col justify-center items-center" style='background-image: url("homepage.png"); background-size: 50%; background-repeat: no-repeat; background-position: center;'>
    <img src='homepage3.png' id='homepage' class='homepage' style='z-index: -1; transform: rotate(0deg);' alt='logo' width='120%' />
  </div>
  <div class="bannerOpacity border-blue-900 h-full w-full relative flex  flex-col justify-center items-center">
      <div class="flex flex-inline">
          <h1 class="lg:text-6xl font-bold text-white pt-8 md:text-6xl text-4xl">
              <span class='solanaText'>SOLANA</span> +
              <span class='inuText'>INU</span> +
              <span class='neonText'>NEON</span>
          </h1>
      </div>

      <div class='flex flex-inline mt-10 justify-center'>
        {#if featureFlag}
          <Countdown from="2022-12-15 19:00:00" dateFormat="YYYY-MM-DD H:m:s" zone="Europe/Paris" let:remaining>
            <div class="whatever">
                <h4 class="lg:text-3xl font-bold text-white pt-8 md:text-6xl text-4xl">
                  <span class='neonText'>{remaining.days} days</span>
                  <span class='neonText'>{remaining.hours} hours</span>
                  <span class='neonText'>{remaining.minutes} minutes</span>
                  <span class='neonText'>{remaining.seconds} seconds</span>
                </h4>
            </div>
          </Countdown>
        {:else}
          <h4 class="lg:text-3xl font-bold text-white pt-8 md:text-6xl text-4xl">
            <span class='neonText'>Postponed until Neon gets on Mainnet</span>
          </h4>
        {/if}
      </div>
      <br>
      <br>
      <br>

      <div class='flex flex-inline w-full'>
          <a class='flex justify-end w-full mr-10' href='https://twitter.com/Solainu'>
            <img class='socialImgs' style='text-align: -webkit-right;' src='twitter.png'  alt='logo' width='20%' />
          </a>
          <a class='flex justify-start w-full pl-10' href='https://t.me/+TmRtTkOxF_2ONkLC'>
            <img class='socialImgs' style='text-align: -webkit-left;' src='telegram.png' alt='logo' width='20%' />
          </a>  
      </div>

      {#if featureFlag}
        <div class='flex flex-inline mt-10'>
            <Link href="#/Buy"  className="navBarLink activeLink bg-primary mr-5">Buy</Link>
            <Link href="#/Farm" className="navBarLink activeLink bg-pink-400 ml-5">Farm</Link>
        </div>
      {/if}
  </div>

</div>

{#if featureFlag}
  <div class="bannerOpacity flex items-start justify-center mt-44 text-white">
    <IndexCounter indexCounterCaption='Marketcap'  indexCounterMaxNumber={$priceData['marketCap']}        indexCounterUnit='format' svgName='Marketcap' />
    <IndexCounter indexCounterCaption='TVL'        indexCounterMaxNumber={$priceData['totalValueLocked']} indexCounterUnit='format' svgName='Tvl' />
    <IndexCounter indexCounterCaption='SINU Price' indexCounterMaxNumber={$priceData['sinuPrice']}        indexCounterUnit='dollar' svgName='Dollar' />
  </div>
{/if}


<script>
    import Link from './../components/link.svelte';
    import IndexCounter from './../components/indexCounter.svelte';
    import {fade, blur, fly, slide, scale, draw, crossfade} from 'svelte/transition'
    import { onMount } from 'svelte';
    import { priceData } from './../stores.js';
    import Countdown from 'svelte-countdown/src/index.js';

    $: featureFlag = false;

    onMount(async () => {
      var bannerItems = document.getElementsByClassName('bannerOpacity');
      Array.prototype.forEach.call(bannerItems, function(slide, index) {
          bannerItems[index].style.opacity = 1;
      });


      var startTime = new Date();

      document.addEventListener('mousemove', (e) => {
        if(document.getElementById('homepage')) {
          var width = Math.abs((window.innerWidth / 2 - e.pageX) / 10)  / 30;
          var height = Math.abs((window.innerHeight / 2 - e.pageY) / 5) / 30;

          var currentPosition = parseFloat(document.getElementById('homepage').style.transform.split('rotate(')[1].split('deg')[0])
          var newPosition = currentPosition + height + width +1;

          var currentTime = new Date();
          var timeElapsed = (currentTime - startTime)/1000
          if(Math.round(timeElapsed) > 1) {
            Array.apply(null, {length: (newPosition-currentPosition)}).map(Function.call, Number).map(function (idx) { return idx+currentPosition }).forEach(function(i) {
              if (i == 5000) {
                alert("Well Done ! EasterEgg Found ! Send 'issou' to the Telegram Bot to get a second airdrop!");
              }
              document.getElementById('homepage').style.transform = "rotate("+(i+1)+"deg)";
            })
          }          
        }

      });
    });

</script>